import { AUCTION_EVENTS } from '../../event_bus_modules/auction_bidding';
import { createUniqueCountdownElement } from '../../utils/unique_elements';

$(() => {
  const timerSecondsToClosing =
    parseInt($('input#_seconds-to-closing').val()) || 0;
  const timerSecondsToAuctionStart =
    parseInt($('input#_seconds-to-auction-start').val()) || 0;
  const initialIsInExtendedPeriod = !!parseInt(
    $('#_is-in-extended-period').val()
  );

  const updateTimer = ({
    timerContainers,
    initialization = false,
    secondsToClosing = 0,
    secondsToAuctionStart = 0,
    isInExtendedPeriod = false,
    timerCountdownElement = null,
  }) => {
    const isCountdownToStart = secondsToAuctionStart > 0;
    const secondsToDeadline = isCountdownToStart
      ? secondsToAuctionStart
      : secondsToClosing > 0
      ? secondsToClosing
      : 0;

    const deadline = new Date();
    deadline.setHours(
      deadline.getHours(),
      deadline.getMinutes(),
      deadline.getSeconds() + secondsToDeadline
    );

    // update extension period label visibility
    timerContainers.forEach((timerContainer) => {
      if (isInExtendedPeriod) {
        timerContainer.find('.info').switchClass('d-none', 'd-block');
      }
    });

    const onCountdownUpdate = (event) => {
      const {
        totalHours,
        totalMinutes,
        totalSeconds,
        totalDays,
      } = event.offset;

      const days = ($('#trans-days').html() || 'd')[0];
      const hours = ($('#trans-hours').html() || 'h')[0];
      const minutes = ($('#trans-minutes').html() || 'm')[0];
      const second = $('#trans-second').html() || 'second';
      const seconds = $('#trans-seconds').html() || 'seconds';
      let formatString;

      if (totalDays > 0) {
        formatString = `%-D%!D:${days},${days}; %-H%!H:${hours},${hours}; %-M%!M:${minutes},${minutes};`;
      } else if (totalHours === 0 && totalMinutes < 1) {
        formatString = `%S %!S:${second},${seconds};`;
      } else if (totalHours < 1) {
        formatString = `%M%!M:${minutes},${minutes}; %S%!S:${seconds[0]};`;
      } else {
        formatString = `%-H%!H:${hours},${hours}; %M%!M:${minutes},${minutes}; %S%!S:${seconds[0]};`;
      }

      timerContainers.forEach((timerContainer) => {
        const timer = timerContainer.find('.timer');
        const timerText = timer.find('.text');
        const timerTime = timer.find('.time');

        // sets proper text labels
        timer.addClass(
          isCountdownToStart ? 'timer--to-start' : 'timer--to-end'
        );

        if ((totalSeconds <= 60) & !isCountdownToStart) {
          timer.addClass('active');
          timerTime.addClass('active');
          timerText.addClass('active');
        } else {
          timer.removeClass('active');
          timerTime.removeClass('active');
          timerText.removeClass('active');
        }

        timerTime.html(event.strftime(formatString));
      });
    };

    const onCountdownFinish = () => {
      if (isCountdownToStart) {
        timerContainers.forEach((timerContainer) => {
          const timer = timerContainer.find('.timer');
          timer.removeClass('timer--to-start timer--to-end');
        });
      }

      setTimeout(() => {
        if (isCountdownToStart && secondsToAuctionStart > 0) {
          EVENT_BUS.dispatch(AUCTION_EVENTS.AUCTION_TIME_STARTS);
        } else if (secondsToClosing > 0) {
          EVENT_BUS.dispatch(AUCTION_EVENTS.AUCTION_TIME_ENDED);
        }
      }, 500);
    };

    if (!timerCountdownElement) {
      timerCountdownElement = createUniqueCountdownElement();
    }

    if (initialization) {
      timerCountdownElement
        .off()
        .countdown(deadline)
        .on('update.countdown', onCountdownUpdate)
        .on('finish.countdown', onCountdownFinish);
    } else {
      timerCountdownElement.countdown(deadline);
    }

    return timerCountdownElement;
  };

  const onAuctionClosed = ({ timerContainers, timerCountdownElement }) => {
    timerContainers.forEach((timerContainer) => {
      const timer = timerContainer.find('.timer');
      const timerText = timer.find('.text');
      const timerTime = timer.find('.time');
      const auctionEndText = $('#auction-end-text').html();

      timerContainer.find('.info').switchClass('d-block', 'd-none');
      timer.removeClass('timer--to-start timer--to-end active');
      timer.addClass('ended');
      timerText.html(auctionEndText).removeClass('active');
    });

    timerCountdownElement.remove();
  };

  const timerCurrentBidContainer = $('#timer-sidebar-wrapper .timer-container');
  const timerClosedSidebarContainer = $('#closed-sidebar .timer-container');
  const timerRegisterForAuctionContainer = $(
    '#register-for-auction-timer .timer-container'
  );

  const timerContainers = [
    timerCurrentBidContainer,
    timerClosedSidebarContainer,
    timerRegisterForAuctionContainer,
  ];

  let timerCountdown = updateTimer({
    timerContainers,
    secondsToClosing: timerSecondsToClosing,
    secondsToAuctionStart: timerSecondsToAuctionStart,
    isInExtendedPeriod: initialIsInExtendedPeriod,
    initialization: true,
  });

  const isAuctionClosedOnInitialization =
    timerSecondsToAuctionStart <= 0 && timerSecondsToClosing <= 0;

  if (isAuctionClosedOnInitialization) {
    onAuctionClosed({
      timerContainers,
      timerCountdownElement: timerCountdown,
    });
  }

  EVENT_BUS.on(
    AUCTION_EVENTS.AUCTION_STATUS_UPDATED,
    ({ secondsToClosing, isInExtendedPeriod }) => {
      updateTimer({
        timerContainers,
        secondsToClosing,
        isInExtendedPeriod,
        timerCountdownElement: timerCountdown,
      });
    }
  );

  EVENT_BUS.on(AUCTION_EVENTS.AUCTION_TIME_STARTS, () => {
    const secondsToClosing = timerSecondsToClosing - timerSecondsToAuctionStart;
    updateTimer({
      timerContainers,
      secondsToClosing,
      isInExtendedPeriod: initialIsInExtendedPeriod,
      initialization: true,
      timerCountdownElement: timerCountdown,
    });
  });

  EVENT_BUS.on(AUCTION_EVENTS.AUCTION_CLOSED, () => {
    onAuctionClosed({
      timerContainers,
      timerCountdownElement: timerCountdown,
    });
  });
});
